class ModalDrawer extends HTMLElement {
	constructor() {
		super();

		this.drawerInner = this.querySelector(".drawer__inner");

		this.addEventListener(
			"keyup",
			(evt) => evt.code === "Escape" && this.close()
		);

		const overlay = this.querySelector(".drawer__overlay");
		if (overlay) overlay.addEventListener("click", this.close.bind(this));

		const closeButton = this.querySelector(".drawer__close");
		if (closeButton)
			closeButton.addEventListener("click", this.close.bind(this));
	}

	open(triggeredBy) {
		if (triggeredBy) this.setActiveElement(triggeredBy);

		// The animation doesn't always trigger without deferring the class add.
		setTimeout(() => {
			this.classList.add("animate", "active");
		});

		this.addEventListener(
			"transitionend",
			() => {
				trapFocus(this, this.drawerInner);
			},
			{ once: true }
		);

		document.body.classList.add("overflow-hidden");
	}

	close() {
		this.classList.remove("active");
		removeTrapFocus(this.activeElement);
		document.body.classList.remove("overflow-hidden");
	}

	setActiveElement(element) {
		this.activeElement = element;
	}
}

customElements.define("modal-drawer", ModalDrawer);
